import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-primary mb-6" }, "Datos de la institucion", -1)
const _hoisted_3 = { class: "col-sm-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "Tipo", -1)
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "Nombre corto (abreviado)", -1)
const _hoisted_7 = { class: "col-sm-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "Nombre completo del Club", -1)
const _hoisted_9 = { class: "col-sm-12" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "País", -1)
const _hoisted_11 = { class: "col-sm-12" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "Dirección", -1)
const _hoisted_13 = { class: "col-sm-12" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "Sitio Web", -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'StepInstitution',
  props: {
    form: null,
    listCountries: null
  },
  setup(__props: any) {

const props = __props as {
    form: any;
    listCountries: any;
};



return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_form_item, {
        prop: "category",
        rules: [
                {required: true, message:'Campo obligatorio', trigger:['blur', 'change']}
            ]
      }, {
        label: _withCtx(() => [
          _hoisted_4
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: __props.form.category,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.form.category) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "Club",
                value: "C01"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_form_item, {
        prop: "abrev",
        rules: [
                {required: true, message:'Campo obligatorio', trigger:['blur', 'change']}
            ]
      }, {
        label: _withCtx(() => [
          _hoisted_6
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: __props.form.abrev,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.form.abrev) = $event)),
            maxlength: "10"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_form_item, {
        prop: "name",
        rules: [
                {required: true, message:'Campo obligatorio', trigger:['blur', 'change']}
            ]
      }, {
        label: _withCtx(() => [
          _hoisted_8
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: __props.form.name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.form.name) = $event)),
            maxlength: "100"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_form_item, {
        prop: "idcountry",
        rules: [
                {required: true, message:'Campo obligatorio', trigger:['blur', 'change']}
            ]
      }, {
        label: _withCtx(() => [
          _hoisted_10
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: __props.form.idcountry,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.form.idcountry) = $event)),
            filterable: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.listCountries, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: item?.name,
                  value: item?.idcountry,
                  key: `lst-cou-${index}`
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_el_form_item, {
        prop: "address",
        rules: [
                {required: true, message:'Campo obligatorio', trigger:['blur', 'change']}
            ]
      }, {
        label: _withCtx(() => [
          _hoisted_12
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: __props.form.address,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((__props.form.address) = $event)),
            maxlength: "100"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_el_form_item, { prop: "siteweb" }, {
        label: _withCtx(() => [
          _hoisted_14
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: __props.form.siteweb,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((__props.form.siteweb) = $event)),
            maxlength: "100"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})